export type CalculationMethod = 'AMOUNT' | 'PERCENT';

/**
 * An item (menu-preview weight-tier bucket, or a price-cart line item) can have multiple discounts
 * applied (e.g. a percent-off stacked with a dollar-off). Each discount already carries its own
 * PERCENT/AMOUNT calculationMethod -- this picks one to describe the item as a whole: majority vote
 * across the list, ties defaulting to PERCENT. Entries with no resolvable calculationMethod are
 * excluded rather than guessed; null if none resolve at all.
 */
export const majorityCalculationMethod = (
  discounts: Array<{ calculationMethod?: CalculationMethod | null } | null> | null | undefined
): CalculationMethod | null => {
  const tally = { PERCENT: 0, AMOUNT: 0 };
  // GraphQL's `discounts: [Discount]` allows null list members -- guard via `?.` rather than a
  // `= {}` destructuring default, since that default only covers `undefined`, not a literal `null`
  // element (destructuring `null` throws).
  (discounts ?? []).forEach((discount) => {
    const calculationMethod = discount?.calculationMethod;
    if (calculationMethod === 'PERCENT' || calculationMethod === 'AMOUNT') tally[calculationMethod] += 1;
  });
  if (tally.PERCENT === 0 && tally.AMOUNT === 0) return null;
  return tally.PERCENT >= tally.AMOUNT ? 'PERCENT' : 'AMOUNT';
};
